import React, { useState, useEffect, useCallback, useRef } from "react";
import ClientForm from "../../Components/Client/ClientForm";
import {
  ListClient,
  findClientBySocieteApi,
  desactiveClientApi,
  activeClientApi,
  findNiveauxFidelite,
  setSearchKeyword,
  getSearchKeyword,
  resetClientState,
  getIsInitialized,
} from "../../_App/Redux/Slices/client/clientSlice";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import ClientTable from "../../Components/Client/ClientTable";
import NiveauClientForm from "../../Components/Client/NiveauClientForm";
import NiveauClientTable from "../../Components/Client/NiveauClientTable";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import Navbar from "../../_Layouts/Navbar/Navbar";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

const ClientPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const societe = useAppSelector(societeId);
  const [activeTab, setActiveTab] = useState("client");
  const [showModelClient, setshowModelClients] = useState(false);
  const [showModalNIveau, setshowModalNIveau] = useState(false);
  const [clientitem, setclientitem] = useState<any>(null);
  const [niveauFid, setNiveauFid] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(100);
  const [searchInput, setSearchInput] = useState("");
  const searchKeyword = useAppSelector(getSearchKeyword);
  const isInitialized = useAppSelector(getIsInitialized);

  // Use debounced search to avoid too many API calls
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const client = useAppSelector(ListClient);
  const totalPages = useAppSelector(
    (state: any) => state.clients.totalPages || 1,
  );
  const niveauClient = useAppSelector(
    (state: any) => state.clients.ListNiveauxFidelite || [],
  );

  // Fetch clients with search
  const fetchClients = useCallback(() => {
    if (societe && activeTab === "client") {
      dispatch(
        findClientBySocieteApi({
          id: societe,
          page,
          limit,
          search: searchKeyword,
        }),
      );
    }
  }, [dispatch, societe, page, limit, searchKeyword, activeTab]);

  // Fetch niveau fidelite (only once when component mounts or societe changes)
  useEffect(() => {
    if (societe && !isInitialized) {
      dispatch(findNiveauxFidelite(societe));
    }
  }, [dispatch, societe, isInitialized]);

  // Fetch clients when dependencies change
  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleSearch = () => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      if (societe) {
        dispatch(setSearchKeyword(searchInput));
        setPage(1);
      }
    }, 500);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      dispatch(setSearchKeyword(searchInput));
      setPage(1);
    }
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const verifcationMsg = (msg: string) => {
    return Swal.fire({
      title: t("vous-êtes sûr?"),
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirmer!"),
      cancelButtonText: t("Cancel!"),
    }).then((result) => {
      return result.isConfirmed ? true : false;
    });
  };

  const desactiveFunction = async (id: string) => {
    const isConfirmed = await verifcationMsg(t("Désactiver ce client?"));
    if (isConfirmed) {
      const result = await dispatch(desactiveClientApi(id));
      if (result.payload) {
        ToastSuccess(t("Client désactivé avec succès"));
        fetchClients();
      } else {
        ToastWarning(t("Erreur lors de la désactivation"));
      }
    }
  };

  const activeFunction = async (id: string) => {
    const isConfirmed = await verifcationMsg(t("Activer ce client?"));
    if (isConfirmed) {
      const result = await dispatch(activeClientApi(id));
      if (result.payload) {
        ToastSuccess(t("Client activé avec succès"));
        fetchClients();
      } else {
        ToastWarning(t("Erreur lors de l'activation"));
      }
    }
  };

  const updateFunction = (item: any) => {
    setclientitem(item);
    setshowModelClients(true);
  };

  const updateNveauClientFunction = (item: any) => {
    setNiveauFid(item);
    setshowModalNIveau(true);
  };

  return (
    <div>
      <Navbar title="Client" />
      <div className="container-fluid py-4 home-section">
        {/* Nav tabs */}
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "client" ? "active btn-primary-app" : "text-dark"
              }`}
              onClick={() => handleTabChange("client")}
              type="button"
            >
              {t("Client")}
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "categorie"
                  ? "active btn-primary-app"
                  : "text-dark"
              }`}
              onClick={() => handleTabChange("categorie")}
              type="button"
            >
              {t("Categorie client")}
            </button>
          </li>
        </ul>

        {/* Client Tab */}
        {activeTab === "client" && (
          <>
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex gap-2" style={{ gap: "10px" }}>
                <input
                  type="text"
                  className="form-control"
                  style={{ width: "300px" }}
                  placeholder={t(
                    "Rechercher par nom, code barre ou téléphone...",
                  )}
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <button className="btn btn-primary-app" onClick={handleSearch}>
                  {t("Rechercher")}
                </button>
              </div>
              <button
                className="btn btn-primary-app"
                onClick={() => {
                  setclientitem(null);
                  setshowModelClients(true);
                }}
              >
                {t("Ajouter client")}
              </button>
            </div>

            <ClientForm
              t={t}
              verifcationMsg={verifcationMsg}
              ShowModal={showModelClient}
              setShowModal={setshowModelClients}
              client={clientitem}
              setClient={setclientitem}
              onSuccess={fetchClients}
            />
            {Array.isArray(client) && client.length > 0 ? (
              <ClientTable
                t={t}
                Listclient={client}
                setclientitem={setclientitem}
                desactiveFunction={desactiveFunction}
                activeFunction={activeFunction}
                updateFunction={updateFunction}
                currentPage={page}
                totalPages={totalPages}
                setPage={setPage}
              />
            ) : (
              <p className="text-center text-muted mt-4">{t("aucun client")}</p>
            )}
          </>
        )}

        {/* Categorie Tab */}
        {activeTab === "categorie" && (
          <>
            <div className="d-flex justify-content-end mb-3">
              <button
                className="btn btn-primary-app"
                onClick={() => setshowModalNIveau(true)}
              >
                {t("Ajouter Categorie client")}
              </button>
            </div>

            <NiveauClientForm
              t={t}
              verifcationMsg={verifcationMsg}
              ShowModal={showModalNIveau}
              setShowModal={setshowModalNIveau}
              client={niveauFid}
              onSuccess={() => {
                if (societe) {
                  dispatch(findNiveauxFidelite(societe));
                }
              }}
            />
            {niveauClient && niveauClient.length !== 0 ? (
              <NiveauClientTable
                t={t}
                Listclient={niveauClient}
                setclientitem={setNiveauFid}
                desactiveFunction={desactiveFunction}
                activeFunction={activeFunction}
                updateFunction={updateNveauClientFunction}
              />
            ) : (
              <p className="text-center text-muted mt-4">
                {t("aucun Categorie")}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ClientPage;
